import React, { useEffect, useState } from "react";
import { fetchReportShelterIntakesExits } from "../../../services/httpClient";
import { SingleCardMetric } from "../ui/SingleCardMetric";

interface ShelterExit7DayMetricState {
  data?: any[];
  setSelectedData: (data: any[] | null) => void;
  active: boolean;
  setActive: (active: boolean) => void;
}

export const ShelterExit7DayMetric = ({ data, setSelectedData, active, setActive }: ShelterExit7DayMetricState) => {
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [current, setCurrent] = useState<string>();
  const [currentData, setCurrentData] = useState<any[]>();
  const [readOnly, setReadOnly] = useState<boolean>(true);

  useEffect(() => {
    const fetchData = async () => {
      if (data) {
        const recentExits = data.filter((item: any) => isWithinLast7Days(item.exit_at));
        const recentExitsCount = recentExits.length.toString();
        setCurrent(recentExitsCount);
        setCurrentData(recentExits);
        setReadOnly(false);
        setIsLoading(false);
      } else {
        await getExitsData();
        setIsLoading(false);
      }
    };

    fetchData();
  }, []);

  const getExitsData = async () => {
    await fetchReportShelterIntakesExits()
      .then((res: any) => {
        const data = res[0].data;
        const recentExits = data.filter((item: any) => isWithinLast7Days(item.exit_at));
        const recentExitsCount = recentExits.length.toString();
        setCurrent(recentExitsCount);
        setCurrentData(recentExits);
      })
      .catch((err: any) => {
        console.log(err);
      });
  };

  function isWithinLast7Days(dateStr: string) {
    const today = new Date();
    const exitDate = new Date(dateStr);

    today.setHours(0, 0, 0, 0);
    exitDate.setHours(0, 0, 0, 0);

    const diffInTime: number = today.getTime() - exitDate.getTime();
    const diffInDays = diffInTime / (1000 * 60 * 60 * 24);

    return diffInDays >= 0 && diffInDays <= 8; // 7 days + today
  }

  const onViewDetails = () => {
    if (!active) {
      setSelectedData(currentData || null);
    } else {
      setSelectedData(null);
    }

    setActive(!active);
  };

  if (readOnly) {
    return <SingleCardMetric title={"Exits Last 7 Days"} total={current} isLoading={isLoading} />;
  } else {
    return (
      <SingleCardMetric
        title={"Exits Last 7 Days"}
        total={current}
        onHandleClick={onViewDetails}
        cursor={true}
        active={active}
        isLoading={isLoading}
      />
    );
  }
};
